var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200mm",
    height: "200mm",
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.38,
    cy: 28.34,
    r: 7.54,
    strokeWidth: 0.9339
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2646
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.92,
    cy: 28.34,
    r: 2.136
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.92,
    cy: 52.02,
    r: 2.136
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.92,
    cy: 75,
    r: 2.136
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.38,
    cy: 75,
    r: 2.136
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 34.38,
    cy: 52.02,
    r: 7.451,
    strokeWidth: 0.9229
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.8,
    cy: 28.34,
    r: 7.559,
    strokeWidth: 0.9362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.3,
    cy: 28.34,
    r: 2.136,
    strokeWidth: 0.2646
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.3,
    cy: 52.02,
    r: 7.462,
    strokeWidth: 0.9243
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.3,
    cy: 75,
    r: 2.136,
    strokeWidth: 0.2646
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.8,
    cy: 75,
    r: 7.255,
    strokeWidth: 0.8985
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.8,
    cy: 52.02,
    r: 7.47,
    strokeWidth: 0.9252
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.38,
    cy: 129.2,
    r: 7.796,
    strokeWidth: 0.9655
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.92,
    cy: 129.2,
    r: 2.136,
    strokeWidth: 0.2646
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.92,
    cy: 152.9,
    r: 7.47,
    strokeWidth: 0.9252
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2646
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.92,
    cy: 175.9,
    r: 2.136
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.38,
    cy: 175.9,
    r: 2.136
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.38,
    cy: 152.9,
    r: 2.136
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 141.8,
    cy: 129.2,
    r: 7.397,
    strokeWidth: 0.9161
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.3,
    cy: 129.2,
    r: 7.479,
    strokeWidth: 0.9264
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2646
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 165.3,
    cy: 152.9,
    r: 2.136
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.3,
    cy: 175.9,
    r: 2.136
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.8,
    cy: 175.9,
    r: 2.136
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 141.8,
    cy: 152.9,
    r: 7.537,
    strokeWidth: 0.9335
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2a9482438da1b9e7a75184b772e50e24.svg";
export { ForwardRef as ReactComponent };